// SignerPicker.js
// Engineer and firm dropdowns for a discipline's Report Details. The lists come
// from Settings; picking one fills the signature and firm block on the form.

import React from 'react';
import { useNavigate } from 'react-router-dom';

const SignerPicker = ({ roster, engineerId, firmId, onChange }) => {
  const navigate = useNavigate();
  const engineer = roster.engineers.find(e => e.id === engineerId);
  const firm     = roster.firms.find(f => f.id === firmId);
  const empty    = !roster.engineers.length || !roster.firms.length;

  return (
    <div>
      {empty && (
        <p style={styles.hint}>
          Add engineers and firms in Settings first.{' '}
          <span style={styles.link} onClick={() => navigate('/settings')}>Open Settings</span>
        </p>
      )}
      <div style={styles.row}>
        <div style={styles.field}>
          <label style={styles.label} htmlFor="signer-engineer">Engineer</label>
          <select id="signer-engineer" style={styles.input} value={engineerId || ''}
            onChange={e => onChange({ engineerId: e.target.value, firmId })}>
            <option value="">— Select engineer —</option>
            {roster.engineers.map(e => <option key={e.id} value={e.id}>{e.name || '(unnamed)'}</option>)}
          </select>
          {engineer && (
            <div style={styles.preview}>
              {engineer.qualifications
                ? <div style={{ whiteSpace: 'pre-line' }}>{engineer.qualifications}</div>
                : <div>{engineer.name}{engineer.license ? ` — ${engineer.license}` : ''}</div>}
            </div>
          )}
          {engineerId && !engineer && <p style={styles.warn}>The selected engineer was removed from Settings. Pick again.</p>}
        </div>
        <div style={styles.field}>
          <label style={styles.label} htmlFor="signer-firm">Firm</label>
          <select id="signer-firm" style={styles.input} value={firmId || ''}
            onChange={e => onChange({ engineerId, firmId: e.target.value })}>
            <option value="">— Select firm —</option>
            {roster.firms.map(f => <option key={f.id} value={f.id}>{f.name || '(unnamed)'}</option>)}
          </select>
          {firm && (
            <div style={styles.preview}>
              <div>{firm.name}</div>
              {firm.address && <div>{firm.address}</div>}
              {(firm.phone || firm.email) && <div>{[firm.phone, firm.email].filter(Boolean).join(' · ')}</div>}
              {!firm.logoUrl && <div style={{ color: '#92400e' }}>No logo — photo report footer shows the firm name.</div>}
            </div>
          )}
          {firmId && !firm && <p style={styles.warn}>The selected firm was removed from Settings. Pick again.</p>}
        </div>
      </div>
    </div>
  );
};

const styles = {
  row:     { display: 'flex', gap: '1rem', flexWrap: 'wrap' },
  field:   { display: 'flex', flexDirection: 'column', gap: '0.25rem', flex: 1, minWidth: '240px' },
  label:   { fontSize: '0.875rem', fontWeight: '500', color: '#374151' },
  input:   { padding: '0.5rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '0.9rem', fontFamily: 'inherit', width: '100%', boxSizing: 'border-box' },
  preview: { marginTop: '0.35rem', fontSize: '0.8rem', color: '#374151', backgroundColor: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: '4px', padding: '0.5rem 0.65rem', lineHeight: 1.45 },
  hint:    { margin: '0 0 0.75rem', fontSize: '0.85rem', color: '#4b5563' },
  warn:    { margin: '0.35rem 0 0', fontSize: '0.8rem', color: '#b91c1c' },
  link:    { color: 'cornflowerblue', cursor: 'pointer', fontWeight: '600', textDecoration: 'underline' },
};

export default SignerPicker;
